// Privacy Notice / Terms of Use links for the /succession advisor frontend.
// Rendered in the sidebar footer and the avatar menu when the company has the
// succession_legal_links feature (id 354).

export const LEGAL_LINKS_FEATURE = 'succession_legal_links';

export const POLICIES = {
  privacy: {
    href: '/privacy_policy',
    titleId: 'succession.legal.privacy_notice',
    titleDefault: 'Privacy Notice',
  },
  terms: {
    href: '/terms_of_service',
    titleId: 'succession.legal.terms_of_use',
    titleDefault: 'Terms of Use',
  },
};

// Company features arrive as either `name` or `name_type` depending on the serializer.
export const legalLinksEnabled = (features) => (
  Array.isArray(features)
  && features.some((f) => String(f) === LEGAL_LINKS_FEATURE || String(f) === `${LEGAL_LINKS_FEATURE}_type`)
);

export const trackLegalLinkClick = (policy, location) => {
  try {
    if (window.ahoy?.track) window.ahoy.track('succession_legal_link_clicked', { policy, location });
  } catch (_) {
    // Analytics must never break the click.
  }
};
